<template>
  <div>
    <h4 class="card-title mb-3">
      Charity Report Summary
    </h4>

    <div class="input-group mb-4 d-flex flex-row p2">
      <label style="margin-right: 10px">Charity: </label>
      <div class="form-outline ">
        <select class="form-control" style="width: 300px" :value="charity_id" @change="handleChange">
          <option
            v-for="(charity, index) in allCharities"
            :key="index"
            :value="charity.id"
            >{{ charity.name }}</option
          >
        </select>
      </div>
      <button class="btn btn-primary mr-2" @click="onfilterCharity()">
        Filter
      </button>
    </div>
    <br />

    <div class="row">
      <div class="col-6">
        <label><b>Date From</b></label>
        <input type="date" class="form-control" :value="dateFrom" @change="handleDateChange($event, 1)" />
      </div>
      <div class="col-6">
        <label><b>Date To</b></label>
        <input type="date" class="form-control" :value="dateTo" @change="handleDateChange($event, 2)" />
      </div>
    </div>

    <br />

    <div class="text-left">
      {{ dateFromFormatted != null && dateToFormatted != null
          ? `Reported Date from ${dateFromFormatted} to ${dateToFormatted}`
          : ""
      }}
    </div>

    <div class="text-right">
      <button
        class="btn btn-rounded btn-primary mr-2"
        style="width: 150px;"
        @click="filterSearchCharity()"
      >
        Filter
      </button>
      <button
        class="btn btn-rounded btn-primary"
        style="width: 150px;"
        @click="resetFilter(2)"
      >
        Reset
      </button>
    </div>

    <div class="table-responsive">
      <table
        id="charity_report_summary_table"
        class="display table table-striped table-bordered report-table"
        style="width:100%; text-align: center;"
      >
        <thead>
          <tr>
            <th>No.</th>
            <th>Name</th>
            <th>Points Redeemed</th>
            <th>Points Redeemed in B$</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(charity, index) in charities" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ charity.name }}</td>
            <td>{{ charity.points_redeemed }}</td>
            <td>{{ charity.total_price }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";

export default {
  name: 'charity-page',
  props: {
    allCharities: {
      type: Array,
      required: true
    },

    charities: {
      type: Array,
      required: true
    },

    resetFilter: {
      type: Function,
      required: true
    },

    filterSearchCharity: {
      type: Function,
      required: true
    },

    onfilterCharity: {
      type: Function,
      required: true
    },

    dateFromFormatted: {
      type: String,
      required: false,
      default: null
    },

    dateToFormatted: {
      type: String,
      required: false,
      default: null
    },

    dateFrom: {
      type: String,
      required: false,
      default: null
    },

    dateTo: {
      type: String,
      required: false,
      default: null
    },

    charity_id: {

      required: false
    },

  },
  component: {
    Pagination
  },

  methods: {
    handleChange(event) {
      const newValue = event.target.value;
      this.$emit('onCharitySelected', newValue);
    },

    handleDateChange(event, type) {
      const newValue = event.target.value;
      this.$emit('onChangeDate', newValue, type);
    },
  }
}
</script>

